import {DatasetColumnDataType, DatasetColumnRole} from "@vesta/vos-types/modules/workspaceLevel/domain/Dataset";
import type {RawData} from "@vesta/vos-types/modules/workspaceLevel/domain/RawDataType";

export function replaceNullStringDimensionsWithOthers(rawData: RawData): RawData {
    const stringDimensionColumnIndices = new Set(
        rawData.columnMetadata
            .filter(
                (column) =>
                    column.role === DatasetColumnRole.dimension && column.dataType === DatasetColumnDataType.string,
            )
            .map((column) => column.columnIndex),
    );
    if (stringDimensionColumnIndices.size === 0) {
        return rawData;
    }

    return {
        ...rawData,
        dataPoints: rawData.dataPoints.map((row) =>
            row.map((cell, columnIndex) =>
                stringDimensionColumnIndices.has(columnIndex) === true && cell.value === null
                    ? {...cell, value: "Others"}
                    : cell,
            ),
        ),
    };
}
